module.exports = __webpack_public_path__ + "img/home4.4ba15adf.png";